module.exports = __webpack_public_path__ + "static/media/cbi-logo-charcoal.15d7a46d.svg";